<template>
  <div class="passenger-form-row">
    <div class="passenger-item-title">
      <h3>联系人信息</h3>
    </div>
    <div class="passenger-item-content">
      <div class="passenger-wrap clearfix">
        <div class="field-outter">
          <a-form-item label="姓名" required>
            <a-input
              placeholder="请输入姓名"
              v-decorator="[
                `customer.fullName`,
                {
                  rules: [
                    {
                      validator: handleFieldValidate
                    }
                  ],
                  validateTrigger: 'blur'
                }
              ]"
              size="large"
            />
          </a-form-item>
        </div>
        <div class="field-outter field-long contact-mobile">
          <a-form-item label="联系电话" required>
            <a-input
              class="min-after"
              placeholder="请输入手机号码"
              v-decorator="[
                    `customer.contactMobile`,
                    {
                      rules: [
                        { validator: handleFieldValidate }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
              size="large"
            >
              <a-select
                class="counrty-code-select"
                showSearch
                slot="addonBefore"
                :dropdownMatchSelectWidth="false"
                :filterOption="countryCodefilter"
                optionLabelProp="value"
                v-decorator="[
                  `customer.countryCode`,
                  { initialValue: '86' }
                ]"
              >
                <a-select-option
                  v-for="(d, index) in countryCodeArr"
                  :key="index"
                  :value="d.value"
                  :data="`${d.value} ${d.label} ${d.desc} ${d.icon}`"
                >{{d.label}}-{{d.value}}</a-select-option>
              </a-select>
            </a-input>
          </a-form-item>
        </div>
        <div class="field-outter field-long">
          <a-form-item label="电子邮件" :required="ifInternational">
            <a-input
              placeholder="请输入邮箱号码"
              v-decorator="[
              `customer.email`,
              {
                rules: [
                  {
                    validator: handleFieldValidate
                  }
                ],
                validateTrigger: 'blur'
              }
            ]"
              size="large"
            />
          </a-form-item>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contacts',
  props: {
    ifInternational: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      countryCodeArr: [],
      airline: window.__MICRO_ROOT__?.airline
    }
  },
  created () {
    let t = this
    require.ensure([], (require) => {
      t.countryCodeArr = require('@/assets/js/countrycode').default
    })
  },
  mounted () {
    this.$emit('initContactData')
  },
  methods: {
    handleFieldValidate (rule, value, callback) {
      this.$emit('inputItemValide', rule.fullField, value, callback)
    },
    countryCodefilter (input, option) {
      return option.data.attrs.data.toLowerCase().indexOf(input) >= 0
    }
    /* onNameChange (e) {
      this.$emit('inputItemValide', 'name', e)
    },
    onPhoneChange (e) {
      this.$emit('inputItemValide', 'phone', e)
    },
    onEmailChange (e) {
      // this.$emit('inputItemValide', 'email', e)
    } */
  }
}
</script>
<style lang="less">
@import "formStyle";

.ant-form-vertical
  .field-outter.contact-mobile
  .ant-form-item
  .ant-form-item-label {
  padding-left: 65px;
}
</style>
